import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo";
import ZOOPLA_COMPARABLE_BY_UPRN from "../apollo/zooplaComparableByUPRNv2.gql";
import { ZooplaComparable } from "react-migration/lib/typings/Zoopla";

interface ZooplaComparableHookResponseV2 {
  uprn?: string;
  loading: boolean;
  data?: ZooplaComparable;
}

interface ZooplaComparableResultV2 {
  zooplaComparableByUPRNs: ZooplaComparable[];
}

export function useZooplaComparableByUPRNv2({
  uprn,
  skip,
}: {
  uprn?: string;
  skip?: boolean;
}): ZooplaComparableHookResponseV2 {
  const { loading, data } = useQuery<ZooplaComparableResultV2>(ZOOPLA_COMPARABLE_BY_UPRN, {
    variables: { uprns: [uprn] },
    client: routedClient,
    skip: !uprn || skip,
    context: {
      endpoint: LandTechEndpoints.Gateway,
    },
  });

  return useMemo(
    () => ({
      loading,
      data: data?.zooplaComparableByUPRNs?.[0],
      uprn,
    }),
    [data?.zooplaComparableByUPRNs, loading, uprn]
  );
}
